/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPlayerRecord = createReactComponent("player-record", "IconPlayerRecord", [
  ["path", { d: "M12 12m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0", key: "svg-0" }]
]);

export { IconPlayerRecord as default };
//# sourceMappingURL=IconPlayerRecord.js.map
